// extracted by mini-css-extract-plugin
export default {"button":"arrow-icons-button_button__VhmSQ"};